<template>
  <v-app>
    <v-main class="prayer-screen">
      <v-container fluid class="pa-0 fill-height flex-column align-center no-scroll" v-if="Business">
        
        <div class="content-wrapper">
          <!-- Header -->
          <div class="header-section pt-2 px-6">
            <v-row align="center" no-gutters>
              <v-col class="text-left white--text">
                <div class="text-h6 font-weight-bold" v-if="Business.name">{{ Business.name }}</div>
              </v-col>
              <v-col class="text-right">
                <v-img v-if="Business.imageUrl" :src="Business.imageUrl" contain max-height="60" max-width="60" class="ml-auto bg-white rounded-sm"></v-img>
              </v-col>
            </v-row>
          </div>

          <!-- Time & Countdown -->
          <div class="time-section text-center white--text">
            <div class="current-time font-weight-bold">{{ currentTime }}</div>
            <div class="next-iqamah cyan--text text--lighten-3 font-weight-bold">NEXT IQAMAH IN {{ countdown }}</div>
          </div>

          <!-- Dates -->
          <div class="date-section px-8 white--text">
            <v-row no-gutters>
              <v-col class="text-left font-weight-bold text-uppercase date-text">{{ realDate }}</v-col>
              <v-col class="text-right font-weight-bold text-uppercase date-text">{{ islamicDate }}</v-col>
            </v-row>
          </div>

          <!-- Prayer Table -->
          <div class="prayer-table px-6">
            <v-row class="table-header py-1 text-center cyan--text text--lighten-4 font-weight-bold" no-gutters>
              <v-col cols="4"></v-col>
              <v-col cols="4">STARTS</v-col>
              <v-col cols="4">IQAMAH</v-col>
            </v-row>

            <div v-for="prayer in prayers" :key="prayer.name" class="prayer-row py-2">
              <v-row align="center" no-gutters>
                <v-col cols="4" class="text-left prayer-name font-weight-medium white--text">{{ prayer.name }}</v-col>
                <v-col cols="4" class="text-center prayer-time white--text font-weight-light">{{ prayer.starts }}</v-col>
                <v-col cols="4" class="text-center prayer-time white--text font-weight-bold">{{ prayer.iqamah }}</v-col>
              </v-row>
            </div>
          </div>

          <!-- Footer Cards -->
          <div class="footer-section px-4 pb-2">
            <v-card color="white" light class="pa-2 text-center rounded-lg mb-2" elevation="0">
              <div class="footer-text font-weight-bold" style="color: #0d1b3e;">
                SUNRISE 7:15AM | SUNSET 4:34PM
              </div>
            </v-card>
            <v-card color="white" light class="pa-2 text-center rounded-lg" elevation="0">
              <div class="font-weight-black jummah-title" style="color: #0d1b3e;">JUMU'AH</div>
              <v-row no-gutters>
                <v-col>
                  <div class="font-weight-bold jummah-time" style="color: #0d1b3e;">1:30PM</div>
                  <div class="jummah-sub font-weight-bold">JUMU'AH 1</div>
                </v-col>
                <v-col>
                  <div class="font-weight-bold jummah-time" style="color: #0d1b3e;">2:15PM</div>
                  <div class="jummah-sub font-weight-bold">JUMU'AH 2</div>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </div>

      </v-container>

      <v-layout v-else fill-height align-center justify-center ma-0>
        <v-progress-circular indeterminate color="white"></v-progress-circular>
      </v-layout>
    </v-main>
  </v-app>
</template>

<script>
import applicationService from "@/modules/Application/service.js";

export default {
  data() {
    return {
      Business: null,
      currentTime: '',
      realDate: '',
      islamicDate: '',
      countdown: '',
      timer: null,
      prayers: [
        { name: 'FAJR', starts: '5:36AM', iqamah: '6:15AM', h: 6, m: 15 },
        { name: 'DHUHR', starts: '11:58AM', iqamah: '1:15PM', h: 13, m: 15 },
        { name: 'ASR', starts: '2:52PM', iqamah: '3:15PM', h: 15, m: 15 },
        { name: 'MAGRIB', starts: '4:34PM', iqamah: '4:37PM', h: 16, m: 37 },
        { name: 'ISHA', starts: '5:55PM', iqamah: '8:00PM', h: 20, m: 0 }
      ]
    }
  },
  created() {
    this.loadBusiness()
    this.updateData()
    this.timer = setInterval(this.updateData, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    loadBusiness() {
      let id = this.$route.params.code;
      applicationService
        .getBusinessInformation({ key: id })
        .then((response) => {
          this.Business = response.data;
          if (!this.Business) {
            this.$router.push({ name: "pagenotfound", params: { '0': this.$route.path } }).catch(() => {});
          }
        })
        .catch((error) => {
          console.log("error getting business", error);
          this.$router.push({ name: "pagenotfound", params: { '0': this.$route.path } }).catch(() => {});
        });
    },
    updateData() {
      const now = new Date()
      this.currentTime = now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
      this.realDate = now.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' })
      let iDate = new Intl.DateTimeFormat('en-TN-u-ca-islamic', { day: 'numeric', month: 'long', year: 'numeric' }).format(now)
      this.islamicDate = iDate.includes("AH") ? iDate : iDate + " AH"
      this.calculateCountdown(now)
    },
    calculateCountdown(now) {
      let nextTime = null
      for (let p of this.prayers) {
        let pDate = new Date()
        pDate.setHours(p.h, p.m, 0)
        if (pDate > now) {
          nextTime = pDate
          break
        }
      }
      if (!nextTime) {
        nextTime = new Date()
        nextTime.setDate(nextTime.getDate() + 1)
        nextTime.setHours(this.prayers[0].h, this.prayers[0].m, 0)
      }
      const diff = nextTime - now
      const hours = Math.floor(diff / 3600000)
      const minutes = Math.floor((diff % 3600000) / 60000)
      this.countdown = `${hours}HR ${minutes}MIN`
    }
  }
}
</script>

<style scoped>
.prayer-screen {
  background: linear-gradient(180deg, #0d1b3e 0%, #152b63 100%);
  height: 100vh;
  width: 100vw;
  overflow: hidden !important;
}

.no-scroll {
  overflow: hidden !important;
  height: 100vh;
}

.content-wrapper {
  width: 100%;
  max-width: 550px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 5px;
}

.current-time {
  font-size: clamp(2.5rem, 11vh, 5.5rem);
  line-height: 1;
}

.next-iqamah {
  font-size: clamp(0.7rem, 2vh, 1.1rem);
}

.date-text {
  font-size: clamp(0.7rem, 1.8vh, 1rem);
}

.prayer-row {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.prayer-name {
  font-size: clamp(0.9rem, 2.2vh, 1.3rem);
  letter-spacing: 1px;
}

.prayer-time {
  font-size: clamp(1.1rem, 3.2vh, 2rem) !important;
}

.table-header {
  font-size: clamp(0.6rem, 1.5vh, 0.9rem);
  letter-spacing: 2px;
}

.footer-text {
  font-size: clamp(0.7rem, 1.8vh, 1rem);
}

.jummah-title {
  font-size: clamp(0.7rem, 1.5vh, 0.9rem);
}

.jummah-time {
  font-size: clamp(0.9rem, 2.2vh, 1.4rem);
}

.jummah-sub {
  font-size: clamp(0.5rem, 1.2vh, 0.75rem);
}

.bg-white {
  background-color: white !important;
}

@media (min-width: 768px) and (max-width: 1024px) {
  .content-wrapper {
    max-width: 85%;
  }
  .prayer-row {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
}

@media (max-width: 600px) {
  .content-wrapper {
    max-width: 100%;
  }
  .current-time {
    font-size: 3.5rem;
  }
}
</style>